/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Settings_Collaborators_TitleInputs */

const en_settings_collaborators_title = /** @type {(inputs: Settings_Collaborators_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Collaborators`)
};

/**
* | output |
* | --- |
* | "Collaborators" |
*
* @param {Settings_Collaborators_TitleInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const settings_collaborators_title = /** @type {((inputs?: Settings_Collaborators_TitleInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Settings_Collaborators_TitleInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_settings_collaborators_title(inputs)
});